import React, { useEffect } from 'react';
import { BsGithub } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa';
import { FaReact, FaNodeJs } from 'react-icons/fa';
import { SiMongodb, SiTailwindcss, SiFirebase, SiReactrouter } from 'react-icons/si';


import img1 from '../../../images/project-details/abroad-portals/resized/1.png';
import img2 from '../../../images/project-details/abroad-portals/resized/2.png';
import img3 from '../../../images/project-details/abroad-portals/resized/3.png';
import img4 from '../../../images/project-details/abroad-portals/resized/4.png';
import img5 from '../../../images/project-details/abroad-portals/resized/5.png';
import img6 from '../../../images/project-details/abroad-portals/resized/6.png';
import img7 from '../../../images/project-details/abroad-portals/resized/7.png';
import img8 from '../../../images/project-details/abroad-portals/resized/8.png';
import img9 from '../../../images/project-details/abroad-portals/resized/9.png';
import img10 from '../../../images/project-details/abroad-portals/resized/10.png';
import img11 from '../../../images/project-details/abroad-portals/resized/11.png';
import img12 from '../../../images/project-details/abroad-portals/resized/12.png';
import img13 from '../../../images/project-details/abroad-portals/resized/13.png';
import img14 from '../../../images/project-details/abroad-portals/resized/14.png';
import img15 from '../../../images/project-details/abroad-portals/resized/15.png';
import img16 from '../../../images/project-details/abroad-portals/resized/16.png';
import img17 from '../../../images/project-details/abroad-portals/resized/17.png';
import img18 from '../../../images/project-details/abroad-portals/resized/18.png';
import img19 from '../../../images/project-details/abroad-portals/resized/19.png';
import img20 from '../../../images/project-details/abroad-portals/resized/20.png';
import img21 from '../../../images/project-details/abroad-portals/resized/21.png';
import img22 from '../../../images/project-details/abroad-portals/resized/22.png';
import img23 from '../../../images/project-details/abroad-portals/resized/23.png';





import AbroadPortalsLarge from '../../../images/projects-large-image/AbroadPortals.png';
import './AbroadPortalsDetails.css';




import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import NewPageSticky from '../../NewPageSticky/NewPageSticky';
import { useLanguage } from '../../../context/LanguageContext';
import useTitle from '../../../Hooks/useTitle';







const AbroadPortalsDetails = () => {

    useTitle('Project | Abroad Portals')


    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])




    //details er 1st pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const divStyle = {
        backgroundImage: ` url(${AbroadPortalsLarge})`,
        transition: 'ease-in 8s'
    };
    const handleHover = () => {
        divStyle.transition = 'ease 8s'
    };
    const handleUnHover = () => {
        divStyle.transition = 'ease 1s'
    };




    const { language } = useLanguage();






    return (
        <div className='lg:mt-10 md:mt-6 mt-4'>



            <div className='flex justify-center items-center md:flex-row lg:flex-row sm:flex-col-reverse flex-col-reverse lg:mb-10 md:mb-8 sm:mb-10 mb-10 mt-12'>
                <h1 className='uppercase text-center text-2xl sm:text-2xl md:text-4xl lg:text-4xl  animation lg:mt-0 md:mt-8 sm:mt-10 mt-10' data-aos='flip-right'>Abroad <span className='text-rose-600 lg:text-6xl md:text-5xl text-[40px] ml-3'>Portals</span></h1>
            </div>



            <div className='lg:px-2 px-0'>
                <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-x-1  gap-y-6 mb-24 animation' data-aos='zoom-in'>

                    <div className='lg:w-[460px] md:w-[335px] sm:w-[355px] w-[355px]  mx-auto' >
                        <div
                            style={divStyle}
                            onMouseEnter={handleHover}
                            onMouseLeave={handleUnHover}
                            className=" bg-top bg-cover  hover:bg-bottom rounded-lg  lg:w-[460px] lg:h-[308px] md:w-[330px] md:h-[220px] sm:w-[338px] sm:h-[220px] w-[338px] h-[220px] mx-auto"></div>
                    </div>


                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 ">
                        <img className='rounded-lg ' src={img23} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img2} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img3} alt="abroad!" />
                    </div>

                    <div className=" mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img4} alt="abroad!" />
                    </div>

                    <div className="   mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img5} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img6} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img7} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img8} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img9} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img10} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img11} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img12} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img13} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img14} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img15} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img16} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img17} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img18} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img19} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img20} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img21} alt="abroad!" />
                    </div>

                    <div className="  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img22} alt="abroad!" />
                    </div>

                </div>
            </div>





            <div>
                <h1 className='uppercase my-10 text-center text-3xl sm:text-3xl md:text-5xl lg:text-5xl font-mono text-cyan-600 font-bold ' >Features & Source Code
                </h1>

                <div className="flex justify-evenly  lg:flex-row md:flex-col-reverse sm:flex-col-reverse flex-col-reverse lg:mx-0 md:mx-8 sm:mx-4 mx-3 mb-24 gap-x-10">

                    <div className="bg-gray-800 px-6 py-6 rounded-2xl shadow-2xl w-full sm:w-full md:w-full lg:w-2/4">
                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ Abroad Portals is an Educational Consultancy Firm in Bangladesh which offers services and consultancy related to studying abroad. We are a community-based platform run by a group of international students from different countries </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ Abroad Portals বাংলাদেশের একটি শিক্ষাগত পরামর্শদাতা প্রতিষ্ঠান যা বিদেশে অধ্যয়ন সংক্রান্ত পরিষেবা এবং পরামর্শ প্রদান করে। আমরা একটি প্ল্যাটফর্ম যা বিভিন্ন দেশের আন্তর্জাতিক ছাত্রদের দ্বারা পরিচালিত হয় </h1> <br></br>
                                </>
                        }


                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ This website is made by using React Router DOM, Firebase Authentication, amd Mongodb as the database. CRUD operation is done where needed. Besides tailwind css is used for the styling purpose. Some component libraries are also used for the design. </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ এই ওয়েবসাইটটি React Router DOM, Firebase Authentication এবং Mongodb ব্যবহার করে তৈরি করা হয়েছে। যেখানে প্রয়োজন সেখানে CRUD অপারেশন করা হয়। টেইলউইন্ড সিএসএস স্টাইলিং উদ্দেশ্যে ব্যবহার করা হয়। কিছু কম্পোনেন্ট লাইব্রেরিও ডিজাইনের জন্য ব্যবহার করা হয়।</h1> <br></br>
                                </>
                        }


                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ React hot toast and sweet alert is added to show the alerts for better user experience. I have used node.js and express.js for the server purpose. All the data are sent to the mongodb server. There is no static data in this project. </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ একটি ভাল ব্যবহারকারীর অভিজ্ঞতার জন্য সতর্কতাগুলি দেখানোর জন্য React Hot Toast এবং Sweet Alert ব্যবহার করা হয়েছে ৷ আমি সার্ভারের উদ্দেশ্যে node.js এবং express.js ব্যবহার করেছি। সমস্ত ডেটা MongoDB সার্ভারে পাঠানো হয়। এই প্রকল্পে কোন স্ট্যাটিক ডেটা নেই।</h1> <br></br>
                                </>
                        }


                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ Authentication is an important part of the website. There are some routes that are private routes. Which means a user can not visit the route if he is not logged in. For the Authentication purpose I have used the google's Firebase authentication system. I have added some authentication systems. Email-Password Login and Google Login. </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ Authentication ওয়েবসাইটের একটি গুরুত্বপূর্ণ অংশ। কিছু রুট আছে যেগুলো ব্যক্তিগত রুট। এর মানে একজন ব্যবহারকারী লগ ইন না করলে রুটটি দেখতে পারবেন না। Authentication এর উদ্দেশ্যে আমি গুগলের ফায়ারবেস Authentication সিস্টেম ব্যবহার করেছি। তাছাড়া আমি আরো কিছু Authentication  সিস্টেম যোগ করেছি যেমন ইমেল-পাসওয়ার্ড লগইন এবং গুগল লগইন</h1> <br></br>
                                </>
                        }


                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ At first the user has to sign in with the website as student. After sign in he/she will be redirected to a form where he/she needs to add all the necessary information so that Abroad Portals can send notification or contact if needed. </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ প্রথমে, ব্যবহারকারীকে ছাত্র হিসাবে ওয়েবসাইটে সাইন ইন করতে হবে। সাইন ইন করার পরে, তাকে একটি ফর্মে পুনঃনির্দেশিত করা হবে যেখানে তাকে সমস্ত প্রয়োজনীয় তথ্য যোগ করতে হবে যাতে Abroad Portals তার সাথে প্রয়োজনে বিজ্ঞপ্তি পাঠাতে বা যোগাযোগ করতে পারে।</h1> <br></br>
                                </>
                        }


                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ A student can visit the country page and choose the countries with us. We provide all the supports to the students till he/she reaches the desire country. We assign a mentor according to the country he/she has choses. Student can chose country by taking our consultancy if he/she faces any difficulties. </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ একজন শিক্ষার্থী আমাদের সাথে তার পছন্দের দেশ বেছে নিতে পারে। যতক্ষণ পর্যন্ত না তিনি কাঙ্খিত দেশে পৌঁছান ততক্ষণ পর্যন্ত আমরা ছাত্রদের সমস্ত সহায়তা প্রদান করি। তিনি যে দেশটি বেছে নিয়েছেন সেই অনুযায়ী আমরা একজন পরামর্শদাতা নিয়োগ করি। শিক্ষার্থী কোনো অসুবিধার সম্মুখীন হলে আমাদের পরামর্শ নিয়ে দেশ বেছে নিতে পারে ।</h1> <br></br>
                                </>
                        }



                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ If all goes well then a student can register with us and can move forward by taking our services. We will assign a mentor with the student. A student can see the mentors details after sign in. All our mentors are highly qualified and have experience of working in this field over 5 years. </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ সবকিছু ঠিকঠাক থাকলে একজন শিক্ষার্থী আমাদের সাথে নিবন্ধন করতে পারে এবং আমাদের সেবা গ্রহণ করে এগিয়ে যেতে পারে। আমরা ছাত্রের সাথে একজন পরামর্শদাতা নিয়োগ করব। একজন ছাত্র সাইন ইন করার পরে পরামর্শদাতাদের বিশদ দেখতে পারেন৷ আমাদের সমস্ত পরামর্শদাতা অত্যন্ত যোগ্য এবং ৫ বছরেরও বেশি সময় ধরে এই ক্ষেত্রে কাজ করার অভিজ্ঞতা রয়েছে ।</h1> <br></br>
                                </>
                        }


                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ Students can book appointment with a mentor if he/she finalize the country which he/she wants to study. Further a student can send direct message to a mentor according to the country he/she has chosen. Once a mentor receives the message he will reply to the queries. </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ শিক্ষার্থীরা কোন পরামর্শদাতার সাথে অ্যাপয়েন্টমেন্ট বুক করতে পারে যদি তারা যে দেশে পড়তে চায় তা চূড়ান্ত করে। এছাড়াও একজন শিক্ষার্থী তার বেছে নেওয়া দেশ অনুযায়ী একজন পরামর্শদাতার কাছে সরাসরি বার্তা পাঠাতে পারে। একবার একজন পরামর্শদাতা বার্তাটি পেলে তিনি প্রশ্নের উত্তর দেবেন</h1> <br></br>
                                </>
                        }



                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ As, there are several users in this project. Student, Mentor, Admin are the main users of this website. So, I have made a dashboard and differentiate the users based on their role. All the users will have different dashboard layouts and different options accordingly to their role. </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ এই প্রকল্পে বেশ কিছু ব্যবহারকারী আছে. স্টুডেন্ট, মেন্টর, অ্যাডমিন এই ওয়েবসাইটের প্রধান ব্যবহারকারী। তাই, আমি একটি ড্যাশবোর্ড তৈরি করেছি এবং ব্যবহারকারীদের ভূমিকার উপর ভিত্তি করে পার্থক্য করেছি। সমস্ত ব্যবহারকারীর ভূমিকা অনুযায়ী বিভিন্ন ড্যাশবোর্ড লেআউট এবং বিভিন্ন বিকল্প থাকবে</h1> <br></br>
                                </>
                        }


                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ A mentor can see all the appointments and messages he got and can provide services accordingly. Our mentor are available 24/7 and a student can knock the mentor any time he/she wants. </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ একজন পরামর্শদাতা তার সমস্ত অ্যাপয়েন্টমেন্ট এবং বার্তা দেখতে পারেন এবং সেই অনুযায়ী পরিষেবা প্রদান করতে পারেন। আমাদের পরামর্শদাতা 24/7 উপলব্ধ এবং একজন ছাত্র যে কোন সময় পরামর্শদাতাকে নক করতে পারে ।</h1> <br></br>
                                </>
                        }


                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ Admin has the highest authority where he/she can view all students information, all mentors information. Admin can perform CRUD operation along with the operational tasks. If any problem occurs then admin will be fixing it. </h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ অ্যাডমিনের সর্বোচ্চ কর্তৃত্ব রয়েছে যেখানে তিনি সমস্ত ছাত্রদের তথ্য, সমস্ত পরামর্শদাতার তথ্য দেখতে পারেন। প্রশাসক অপারেশনাল কাজ সহ CRUD অপারেশন করতে পারেন। কোন সমস্যা দেখা দিলে এডমিন ঠিক করে দিবেন ।</h1> <br></br>
                                </>
                        }


                        {
                            language === 'english' ?
                                <>
                                    <h1 className='text-justify text-lg'> ⚪ Chatting is one of the key features of this website. We have build live chatting feature for the students, mentors and admin respectively. If a student want then he can send message to the respected mentor and out mentor will reply to his message. Mentor can chat with students and admin. For the pricacy policy we have restricted one mentor's messgae to another mentor. All the messages and replies are shown in real time.</h1> <br></br>
                                </>
                                :
                                <>
                                    <h1 className='text-justify text-lg' > ⚪ চ্যাটিং এই ওয়েবসাইটের অন্যতম প্রধান বৈশিষ্ট্য। আমরা যথাক্রমে ছাত্র, পরামর্শদাতা (Mentor) এবং প্রশাসকদের (Admin) জন্য একটি লাইভ চ্যাটিং পদ্ধতি তৈরি করেছি। একজন ছাত্র চাইলে সে সম্মানিত পরামর্শদাতাকে বার্তা পাঠাতে পারে এবং আমাদের পরামর্শদাতা তার বার্তার উত্তর দেবেন। পরামর্শদাতারা ছাত্র এবং প্রশাসকদের সাথেও চ্যাট করতে পারেন। প্রাইসিসি নীতির জন্য আমরা একজন পরামর্শদাতার বার্তাকে অন্য পরামর্শদাতার কাছে সীমাবদ্ধ করেছি। সমস্ত বার্তা এবং উত্তর বাস্তব সময়ে দেখানো হয় ।</h1> <br></br>
                                </>
                        }

                    </div>





                    <div className='w-full sm:w-full md:w-full lg:w-2/4 '>

                        <h2 className='text-center text-3xl mt-4 mb-12 '>GitHub Links <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                        <div className=' '>

                            <a href='https://abroad-portals.web.app/' target='blank' title='Live Site Demo'>
                                <div className='relative group mt-4 animation' data-aos='fade-left'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-gradient-to-r from-pink-600 to-violet-400 opacity-70 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Live Website</span>
                                            <FaEye className='text-3xl text-white'></FaEye>
                                        </div>
                                    </button>
                                </div>
                            </a>




                            <a href='https://github.com/Fahimsakib1/abroad-portals-client' target='blank' title='Client Side Code'>
                                <div className='relative group mt-4 animation' data-aos='fade-right'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-blue-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Client Side Code</span>
                                            <BsGithub className='text-3xl text-white'></BsGithub>
                                        </div>
                                    </button>
                                </div>
                            </a>

                            <a href='https://github.com/Fahimsakib1/abroad-portals-server' target='blank' title='Server Side Code'>
                                <div className='relative group mt-4 animation' data-aos='fade-left'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-green-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Server Side Code</span>
                                            <BsGithub className='text-3xl text-white'></BsGithub>
                                        </div>
                                    </button>
                                </div>
                            </a>










                        </div>

                        <h2 className='text-center text-3xl mt-12 mb-8 '>Technologies Used <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                        <div className='flex justify-center items-center flex-wrap  gap-x-8 lg:mb-0 md:mb-8 sm:mb-12 mb-12 animation' data-aos='fade-up'>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <FaReact className='text-4xl mx-2 text-cyan-500'></FaReact>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React JS</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <FaNodeJs className='text-4xl mx-2 text-green-500'></FaNodeJs>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Node JS</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiFirebase className='text-4xl mx-2 text-yellow-400'></SiFirebase>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Firebase</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiReactrouter className='text-4xl mx-2 text-red-600'></SiReactrouter>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React Router</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiTailwindcss className='text-4xl mx-2 text-sky-500'></SiTailwindcss>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Tailwind</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiMongodb className='text-4xl mx-2 text-green-500'></SiMongodb>
                                <h1 className='text-white text-2xl py-2  mr-4'>MongoDB</h1>
                            </div>

                        </div>




                    </div>

                </div>

                {/* <div className='mx-auto text-center '>
                    <Link to='/'>
                        <button className='btn btn-primary w-[300px] sm:w-[300px] md:w-[400px] bg-black text-white text-xl border-2  hover:border-teal-500 border-violet-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 border-b-4 border-t-0 border-r-2 border-l-0 hover:bg-black hover:text-white'>Back To Home Page</button>
                    </Link>
                </div> */}


                <div className='text-center my-10 '>
                    <Link to='/'>
                        <button className='cursor-pointer hover:scale-105 hover:duration-300 hover:ease-in-out hover:delay-150 px-6 py-2 rounded-sm  text-white text-lg mt-3 border-0 bg-blue-800' title='Download Resume'>
                            Back To Home Page
                        </button>
                    </Link>
                </div>

            </div>




















        </div>
    );
};

export default AbroadPortalsDetails;